import { ROUTES } from "../../routes/routePaths";

export const seoMeta = {
    [ROUTES.HOME]: {
        title: 'GlobalsBid-Government Tenders Website & Online Tender Search',
        description: 'Looking for tenders? Use GlobalsBid, a leading Government tenders website, to search online tenders and explore our Procurement Notice Portal.',
        keywords: 'government tenders website, online tender search',
    },
    [ROUTES.CONTACT_US]: {
        title: 'Contact Us | GlobalsBid',
        description: 'Contact GlobalsBid, the best global bidding website, for inquiries, support, or partnership opportunities. We\'re here to help you succeed.',
    },
    [ROUTES.ABOUT_US]: {
        title: 'About Us | Bid Search Website | GlobalsBid',
        description: 'GlobalsBid is a bid discovery platform and search engine for bids, helping businesses find and track opportunities across sectors in one place.',
    },
    [ROUTES.ADVANCED_SEARCH]: {
        title: 'Find Global Tenders & Bids | Advanced Search - GlobalsBid',
        description: 'GlobalSBID is a search engine for tenders and a powerful tender discovery platform to find global bids, RFPs, and procurement opportunities.',
    },
    [ROUTES.TENDERS_BY_COUNTRY]: {
        title: 'Global Tenders by Country | International Bids Online',
        description: 'Find new worldwide procurement notices and global tenders by country. Stay updated on international bidding opportunities in all sectors.',
    },
    [ROUTES.TENDERS_BY_GEO_REGION]: {
        title: 'Global Tenders by Region | Geo-Based Bid Listings',
        description: 'Access our worldwide bid database for the latest tenders in Europe, Africa, Americas, and more global regions. Stay ahead with real-time updates.',
    },
    [ROUTES.TENDERS_BY_POLITICAL_REGION]: {
        title: 'Tenders by Political Region | GlobalsBid Tender Portal',
        description: 'Leading global tendering platform offering top international tender listings. Discover bids on the best global bidding website now.',
    },
    [ROUTES.TENDERS_BY_CATEGORY]: {
        title: 'Browse Global Tenders by Category | GlobalsBid',
        description: 'Explore one of the largest tender databases on the biggest tender portal for global bids, contracts, and procurement opportunities across all sectors.',
    },
    [ROUTES.TENDERS_BY_KEYWORDS]: {
        title: 'Latest Tenders by Keywords | Global Tenders Search',
        description: 'Get the latest global tenders, international tender updates, and worldwide tender alerts in one place. Stay informed and win more bids.',
    },
    [ROUTES.TENDERS_FUNDING_AGENCIES]: {
        title: 'Tenders by Funding Agencies | GlobalBids',
        description: 'Explore tender announcement search and public procurement database on GlobalsBid. Find global tenders by funding agencies in one place.',
    },
    [ROUTES.TERMS_AND_CONDITIONS]: {
        title: 'Terms and Conditions | GlobalsBid Official Site',
        description: 'Global tender repository with international tender listings and a worldwide bid database. Explore terms for secure, transparent bidding worldwide.',
    },
    [ROUTES.PRIVACY_POLICY]: {
        title: 'Privacy Policy | GlobalsBid – Your Data, Our Priority',
        description: 'Best global bidding website and trusted online bidding portal for buyers and sellers to connect, bid, and win deals across multiple categories.',
    },
    [ROUTES.REFUND_POLICY]: {
        title: 'Return Policy | Online Bidding Portal | GlobalsBid',
        description: 'Explore the refund policy of the biggest tender portal, GlobalsBid. Transparent, secure, and customer-focused policies to support your bidding needs.',
    },
    [ROUTES.SEARCH_ENGINE_FOR_BIDS]: {
        title: 'Search Engine for Bids – Find Opportunities with GlobalsBid',
        description: 'Find the bids that matter to you with GlobalsBid – a simple, easy-to-use Search Engine for Bids connecting you to opportunities worldwide.',
    },
    [ROUTES.SEARCH_ENGINE_FOR_TENDERS]: {
        title: 'Search Engine for Tenders | Find Global Tender Opportunities',
        description: 'Discover tenders faster with globalsbid. Get real-time alerts, verified listings, and smart filters to find and win the right opportunities.',
    },
    [ROUTES.TENDER_DATABASES]: {
        title: 'Explore the Largest Tender Databases | GlobalsBid',
        description: 'Find verified tenders and global opportunities with ease. Grow your business efficiently through the largest tender databases with GlobalsBid.',
    },
    [ROUTES.TENDERING_PLATFORM]: {
        title: 'Procurement in Global E-Tendering Platform | GlobalsBid',
        description: 'Explore global tenders easily with GlobalsBid\'s trusted global e tendering platform Get real time alerts and win more contracts worldwide.',
    },
    [ROUTES.EXTENSIVE_PROCUREMENT_DATABASE]: {
        title: 'Access an Extensive Procurement Database | GlobalsBid',
        description: 'Explore global tenders with GlobalsBid\'s extensive procurement database Access verified opportunities worldwide and grow your business confidently.',
    },
    [ROUTES.BID_CONSULTANCY_SERVICE]: {
        title: 'Smart Bid Discovery Platform & Consultancy | Globalsbid',
        description: 'Globalsbid helps you win more with expert bid consultancy and a smart bid discovery platform designed to simplify success.',
    },
    [ROUTES.GOVERMENT_AND_PRIVATE_BIDS]: {
        title: 'Guide to Finding Government & Private Bids Online',
        description: 'Discover live tenders fast and easily with Globalsbid Find government and private bids online and grow your business efficiently.',
    },
    [ROUTES.LATEST_GLOBAL_TENDERS]: {
        title: 'GlobalsBid – Explore Global Tenders & Procurement Opportunities',
        description: 'GlobalsBid is your trusted portal to search, filter, and explore international tenders and bids.',
    },
    [ROUTES.LEADING_GLOBAL_TENDERING_PLATFORM]: {
        title: 'Leading Global Tendering Platform | Globalsbid',
        description: 'Access verified tenders and grow internationally using GlobalsBid, the leading global tendering platform trusted by companies worldwide.',
    },
    [ROUTES.TENDERS]: {
        title: 'Search Global Tenders & Bids | GlobalsBid',
        description: 'Search and filter thousands of global tenders, RFPs, and procurement opportunities. Stay updated with real-time bidding alerts on GlobalsBid.',
    },
    [ROUTES.CONTRACTS]: {
        title: 'Global Contract Awards & Procurement Results | GlobalsBid',
        description: 'Access a comprehensive database of global contract awards and procurement results. Track competition and understand market trends with GlobalsBid.',
    },
    [ROUTES.SITE_MAP]: {
        title: 'Site Map | GlobalsBid - Navigate Our Tender Portal',
        description: 'Explore the site map of GlobalsBid to easily find tenders, contracts, categories, regions, and more on our global bidding platform.',
    },
    [ROUTES.FAQ]: {
        title: 'Frequently Asked Questions (FAQ) | GlobalsBid Support',
        description: 'Find answers to common questions about searching for tenders, bidding, subscriptions, and using the GlobalsBid platform.',
    },
    [ROUTES.BLOG]: {
        title: 'Blog | Insights & Guides on Global Tendering | GlobalsBid',
        description: 'Stay informed with the latest insights, bidding tips, and comprehensive guides to help you win more global tenders and procurement contracts.',
    },
    [ROUTES.THANK_YOU]: {
        title: 'Thank You | GlobalsBid',
        description: 'Thank you for connecting with GlobalsBid. We are hard at work to provide you with the best tender discovery experience.',
    },
    [ROUTES.PUBLISH_TENDER]: {
        title: 'Publish Your Tender | Reach Global Bidders | GlobalsBid',
        description: 'Publish your tender notices on GlobalsBid and reach a vast network of global bidders and suppliers to ensure competitive and transparent procurement.',
    },
    [ROUTES.EUROPE_GOVERNMENT_TENDERS]: {
        title: `Europe Government Tenders & Procurement Opportunities ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access over 600,000+ live tenders across Europe. Discover RFPs, EOIs, and government bids updated daily for international and domestic suppliers.',
        keywords: `Europe government tenders, European procurement opportunities, Europe tenders ${new Date().getFullYear()}, RFPs Europe, European bids`
    },
    [ROUTES.EUROPE_GOVERNMENT_TENDERS_ALT]: {
        title: `Europe Government Tenders & Procurement Opportunities ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access over 600,000+ live tenders across Europe. Discover RFPs, EOIs, and government bids updated daily for international and domestic suppliers.',
        keywords: `Europe government tenders, European procurement opportunities, Europe tenders ${new Date().getFullYear()}, RFPs Europe, European bids`
    },
    [ROUTES.REGISTER_FREE_SAMPLE]: {
        title: 'Register to View Tenders & Get Free Data Samples | GlobalsBid',
        description: 'Start your business journey with GlobalsBid. Register now for free sample tenders, AI procurement demo, and custom daily email alerts.',
        keywords: 'register tenders, free sample tenders, tender database access, global procurement demo'
    },
    [ROUTES.DAILY_TENDER_ALERTS]: {
        title: `Register to Get Daily Alerts ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Receive customized daily email alerts for government tenders, RFPs, and contract opportunities tailored to your industry and target region.',
        keywords: 'register daily alerts, email tender notifications, procurement alerts, government bid alerts'
    },
    [ROUTES.POLAND_GOVERNMENT_TENDERS]: {
        title: `Poland Government Tenders & Procurement Opportunities ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access over 45,000+ live tenders across Poland. Discover RFPs, public contracts, and government bids updated daily for international and domestic suppliers.',
        keywords: `Poland government tenders, Polish procurement opportunities, Poland tenders ${new Date().getFullYear()}, Warsaw tenders, BZP Poland`
    },
    [ROUTES.POLAND_GOVERNMENT_TENDERS_ALT]: {
        title: `Poland Government Tenders & Procurement Opportunities ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access over 45,000+ live tenders across Poland. Discover RFPs, public contracts, and government bids updated daily for international and domestic suppliers.',
        keywords: `Poland government tenders, Polish procurement opportunities, Poland tenders ${new Date().getFullYear()}, Warsaw tenders, BZP Poland`
    },
    [ROUTES.IT_SOFTWARE_TENDERS]: {
        title: `IT & Software Government Tenders & Procurement Opportunities ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access over 120,000+ live IT & Software tenders globally. Discover RFPs, EOIs, software development, cloud computing, AI, and cybersecurity contracts updated daily.',
        keywords: `IT government tenders, software procurement opportunities, IT tenders ${new Date().getFullYear()}, software development RFPs, cybersecurity tenders, cloud computing bids`
    },
    [ROUTES.ERP_TENDERS]: {
        title: `ERP Tenders & Software Implementation Opportunities ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Discover over 45,000+ active ERP government tenders globally. Access SAP S/4HANA, Oracle Cloud, and Microsoft Dynamics RFPs updated daily.',
        keywords: `ERP tenders, SAP implementation tenders, Oracle ERP RFPs, Microsoft Dynamics bids`
    },
    [ROUTES.ENGINEERING_CONSULTANCY_TENDERS]: {
        title: `Engineering Consultancy Tenders & Advisory Opportunities ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access over 60,000+ engineering consultancy tenders, civil engineering design RFPs, and project management contracts worldwide.',
        keywords: `engineering consultancy tenders, PMC tenders, civil engineering RFPs, infrastructure design bids`
    },
    [ROUTES.ENVIRONMENTAL_CONSULTANCY_TENDERS]: {
        title: `Environmental Consultancy & ESG Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Find 35,000+ active environmental impact assessment (EIA) tenders, net-zero carbon audits, and waste management consultancy contracts.',
        keywords: `environmental consultancy tenders, EIA tenders, ESG audits, carbon footprint RFPs`
    },
    [ROUTES.HEALTHCARE_TENDERS]: {
        title: `Healthcare & Medical Equipment Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Explore 85,000+ medical equipment tenders, hospital construction RFPs, pharmaceutical procurement, and health IT contracts worldwide.',
        keywords: `healthcare tenders, medical equipment RFPs, hospital tenders, pharmaceutical procurement`
    },
    [ROUTES.CYBERSECURITY_TENDERS]: {
        title: `Cybersecurity & Zero-Trust Government Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access 40,000+ live cybersecurity tenders, SOC management RFPs, vulnerability assessment contracts, and endpoint security bids.',
        keywords: `cybersecurity tenders, SOC tenders, zero trust security RFPs, penetration testing bids`
    },
    [ROUTES.GIS_GEOSPATIAL_TENDERS]: {
        title: `GIS & Geospatial Mapping Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Discover 28,000+ GIS mapping tenders, satellite imagery RFPs, LiDAR survey contracts, and spatial database opportunities globally.',
        keywords: `GIS tenders, geospatial mapping RFPs, satellite imagery tenders, LiDAR survey bids`
    },
    [ROUTES.CONSTRUCTION_TENDERS]: {
        title: `Construction & Civil Works Government Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access 150,000+ live construction tenders, highway building RFPs, civil engineering contracts, and public works projects updated daily.',
        keywords: `construction tenders, civil works RFPs, road building tenders, infrastructure construction`
    },
    [ROUTES.RENEWABLE_ENERGY_TENDERS]: {
        title: `Renewable Energy & Clean Tech Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Discover 55,000+ active utility solar tenders, wind farm development RFPs, battery energy storage (BESS) bids, and green hydrogen projects.',
        keywords: `renewable energy tenders, clean tech RFPs, wind farm tenders, battery storage bids`
    },
    [ROUTES.SOLAR_TENDERS]: {
        title: `Solar Energy & Photovoltaic Government Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Explore 42,000+ solar PV tenders, rooftop solar RFPs, solar street lighting contracts, and utility-scale solar plant procurement worldwide.',
        keywords: `solar energy tenders, rooftop solar RFPs, solar PV bids, solar street light tenders`
    },
    [ROUTES.OIL_GAS_TENDERS]: {
        title: `Oil & Gas Industry Government Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access 50,000+ oil & gas tenders, upstream drilling RFPs, pipeline construction, refinery maintenance, and LNG facility procurement.',
        keywords: `oil and gas tenders, drilling rig RFPs, pipeline construction tenders, refinery bids`
    },
    [ROUTES.RAIL_METRO_TENDERS]: {
        title: `Rail & Metro Transit Government Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Explore 38,000+ metro rail tenders, rolling stock supply RFPs, signaling CBTC contracts, and railway track laying bids globally.',
        keywords: `rail metro tenders, rolling stock RFPs, railway signaling bids, trackwork tenders`
    },
    [ROUTES.WATER_WASTEWATER_TENDERS]: {
        title: `Water & Wastewater Management Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Discover 62,000+ sewage treatment plant (STP) tenders, seawater desalination RFPs, water pipeline laying, and smart metering bids.',
        keywords: `water tenders, wastewater treatment RFPs, desalination plant bids, STP tenders`
    },
    [ROUTES.DEFENCE_TENDERS]: {
        title: `Defence & Military Government Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access 32,000+ military procurement notices, defense equipment RFPs, naval vessel maintenance, and tactical communications tenders.',
        keywords: `defence tenders, military equipment RFPs, naval tenders, tactical communication bids`
    },
    [ROUTES.DRONE_UAV_TENDERS]: {
        title: `Drone & UAV Technology Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Discover 18,000+ drone procurement tenders, aerial survey RFPs, agricultural UAV bids, and counter-drone defense contracts.',
        keywords: `drone tenders, UAV procurement RFPs, anti-drone system bids, aerial survey tenders`
    },
    [ROUTES.SMART_CITY_TENDERS]: {
        title: `Smart City Infrastructure Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Explore 34,000+ Smart City tenders, Integrated Command Center (ICCC) RFPs, intelligent traffic systems, and smart lighting bids.',
        keywords: `smart city tenders, ICCC RFPs, intelligent traffic bids, smart street light tenders`
    },
    [ROUTES.TELECOM_TENDERS]: {
        title: `Telecommunications Government Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access 26,000+ 5G network rollout tenders, fiber optic cable laying RFPs, satellite communications, and telecom equipment bids.',
        keywords: `telecom tenders, 5G network RFPs, fiber optic cable bids, SATCOM tenders`
    },
    [ROUTES.AI_DIGITAL_TRANSFORMATION_TENDERS]: {
        title: `AI & Digital Transformation Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Discover 30,000+ Generative AI tenders, RPA automation RFPs, citizen e-services modernization, and cloud architecture contracts.',
        keywords: `AI tenders, digital transformation RFPs, RPA automation bids, generative AI tenders`
    },
    [ROUTES.CONTRACT_AWARDS_LANDING]: {
        title: `Contract Awards & Public Procurement Results ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access over 500,000+ awarded government contracts, winning contractor profiles, contract values, and pricing intelligence worldwide.',
        keywords: `contract awards, public procurement results, winning contractor data, awarded contract values`
    },
    [ROUTES.WORLD_BANK_UN_TENDERS]: {
        title: `World Bank & UN Procurement Tenders ${new Date().getFullYear()} | GlobalsBid`,
        description: 'Access 50,000+ multilateral development bank tenders from World Bank, ADB, AfDB, EBRD, UNDP, and UNGM for international suppliers.',
        keywords: `World Bank tenders, UNGM procurement, ADB tenders, AfDB development bids`
    },
};
